import React, { useEffect, useState, useRef, useMemo } from 'react'
import LoginLeft from './LoginLeft'
import './login.scss';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useHistory, useLocation } from 'react-router';
import Notify from 'lib/Utils/Alert';
import Authenticate from 'lib/Core/Authenticate';
import NotificationAlert from "react-notification-alert";
import AuthData from 'lib/Core/AuthData';
import Spinner from 'react-bootstrap/Spinner';
import CryptoJS from 'crypto-js';
import { IoArrowBackCircle } from "react-icons/io5";
const securityGroups = [
  "purchaser"
]


const ProvideOtp = () => {
  const history = useHistory()
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [verifyLoader,setVerifyLoader] = useState(false);
  const [disabled,setdisabled] = useState(false)
  const [disableTwo, setDisableTwo] = useState(() => {
    const savedState = sessionStorage.getItem('disableTwo');
    return savedState ? JSON.parse(savedState) : false;
  });

  const [countdown, setCountdown] = useState(() => {
    const savedCountdown = sessionStorage.getItem('countdown');
    return savedCountdown ? JSON.parse(savedCountdown) : 120;
  });
  
  
  const[encrypted,setEncryptedPassword] =useState('');
  const [resendClickCount, setResendClickCount] = useState(0);
  const timerRef = useRef(null);
  const notifyRef = useRef();
  const location = useLocation();
  const { state } = location;
  const smsVerified = JSON.parse(sessionStorage.getItem("smsVerified"))
  const  password = JSON.parse(sessionStorage.getItem("password"));
  const  username = JSON.parse(sessionStorage.getItem("username"));
  const  otpPath = JSON.parse(sessionStorage.getItem("otpPath"));
  const  verifyedPath = JSON.parse(sessionStorage.getItem("verifyed"));
  const pass_key=process.env.REACT_APP_PASS_KEY
  const iv = CryptoJS.lib.WordArray.random(16);
  const checkOTP = () => {
    if (otp.trim().length < 6 || otp.trim().length > 6) {
      setOtpError('Enter a valid OTP')
    }
    else {
      setOtpError(null);
    }
  }

  const authCtl = useMemo(() => new Authenticate(securityGroups), [securityGroups]);
  let processing = false;
  function NotifyWarning(msg) {
    Notify(notifyRef, "warning", msg);
  }



  function NotifyInfo(msg) {
    Notify(notifyRef, "info", msg);
  }

  function NotifyError(msg) {
    Notify(notifyRef, "danger", msg);
  }
  useEffect(() => {
    if (otpPath === "mail") {
      NotifyInfo("A verification code was sent to your email address")
    } else if (otpPath === "sms") {
      NotifyInfo("A verification code was sent to your phone via SMS")
    }
  }, [otpPath])


  useEffect(() => {
    sessionStorage.setItem('disableTwo', JSON.stringify(disableTwo));
  }, [disableTwo]);

  useEffect(() => {
    sessionStorage.setItem('countdown', JSON.stringify(countdown));
  }, [countdown]);

  useEffect(() => {
    // Start the countdown timer if the "disableTwo" state is true
    if (disableTwo && countdown > 0) {
      timerRef.current = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
  
    // When countdown reaches 0, stop the timer and reset states
    if (countdown === 0) {
      clearInterval(timerRef.current);
      setDisableTwo(false);
    }
  
    // Cleanup timer on component unmount
    return () => clearInterval(timerRef.current);
  }, [disableTwo, countdown]);

  // useEffect(() => {
  

  //   if (state?.state?.flag) {
  //     NotifyInfo("A verification code was sent to your Phone number")
  //   }

  // }, [state?.state?.flag])

  const VerifyOtp =  () => {
  
  if(smsVerified === "smsVerified"){
    const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    const ivString = CryptoJS.enc.Base64.stringify(iv);
    const encryptedString = encrypted.toString();
    const finalEncryptedPassword = `${ivString}:${encryptedString}`;
    authCtl.validateMFACode(username, finalEncryptedPassword.trim(), otp)
  .then(data => {
    setVerifyLoader(false);
    if (data.error === "Error: Invalid verification code. Please check the code you entered and try again.") {
      NotifyWarning("Error: Invalid verification code. Please check the code you entered and try again.");
    } else if (data.error === "OTP invalidated due to multiple incorrect attempts. Please request a new OTP.") {
      NotifyWarning("OTP invalidated due to multiple incorrect attempts. Please request a new OTP.");
    } else {
      const tokenValidator = new AuthData(securityGroups, true);
      if (!tokenValidator.setToken(data.accessToken)) {
        NotifyWarning(data.error);
      } else {
        setAccessToken(data.accessToken);
        sessionStorage.setItem("accessToken", JSON.stringify(tokenValidator));
        sessionStorage.removeItem("password");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("otpPath");
        history.replace("/purchaser/dashboard");
        setdisabled(true);
      }
    }
  })
  .catch(error => {
    setVerifyLoader(false);
    NotifyWarning(error);
  
  });
  }else{
    Notify(alert,"danger","no data")
  }
  if (otpError === null) {
    setVerifyLoader(true);
    // if (otpPath=="sms") {
    //  authCtl.verifyPhoneNoVerificationResult(otp, username)
    //     .then(data => {
    //       setVerifyLoader(false);
          
          
          
          
    //       if (data.status === 'true') {
    //         NotifyInfo(data.Message)
            
    //         history.replace('/purchaser-auth/send-otp', { state: { "msg": data.Message } });
    //         // window.location.reload();
    //       } else {
    //         // setVerifiedNumber(false);
           
    //         if(smsVerified === "smsVerified"){

    //         }else{
    //           NotifyError(data.error);
    //         }
            
    //       }
    //     })
    //     .catch(error => {
      
    //       if(smsVerified === "smsVerified"){

    //         }else{
    //           NotifyError(error);
    //         }
    //       setVerifyLoader(false);
    //     });
    // } else {
      if (!disabled) {
        const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
          iv: iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC,
        });
        const ivString = CryptoJS.enc.Base64.stringify(iv);
        const encryptedString = encrypted.toString();
        const finalEncryptedPassword = `${ivString}:${encryptedString}`;
        authCtl.validateMFACode(username, finalEncryptedPassword.trim(), otp)
          .then(data => {
           
            setVerifyLoader(false);
            if (data.error === "Error: Invalid verification code. Please check the code you entered and try again.") {
              NotifyWarning("Error: Invalid verification code. Please check the code you entered and try again.");
            } else if (data.error === "OTP invalidated due to multiple incorrect attempts. Please request a new OTP.") {
              NotifyWarning("OTP invalidated due to multiple incorrect attempts. Please request a new OTP.");
            } else if (data.error === "OTP invalidated due to multiple incorrect attempts. Please request a new OTP.") {
              NotifyWarning(data.error);
              setDisableTwo(true);
              setCountdown(120); 
            } {
              const tokenValidator = new AuthData(securityGroups, true);
              if (!tokenValidator.setToken(data.accessToken)) {
                NotifyWarning(data.error);
              } else {
                setAccessToken(data.accessToken);
                sessionStorage.setItem("accessToken", JSON.stringify(tokenValidator));
                sessionStorage.removeItem("password");
                sessionStorage.removeItem("username");
                sessionStorage.removeItem("otpPath");
                history.replace("/purchaser/dashboard");
                setdisabled(true);
              }
            }
          })
          .catch(error => {
            setVerifyLoader(false);
            NotifyWarning(error);
          console.log("error",error);
          if(error === "OTP invalidated due to multiple incorrect attempts. Please request a new OTP."){
            setDisableTwo(true);
            setCountdown(120); 
          }
          });
      }
    // }
  } else {
    checkOTP();
    setTimeout(() => {
      setVerifyLoader(false);
    }, 1000);
  }
};



  function resendMFA() {
    setResendClickCount(prevCount => prevCount + 1)
    if (!disableTwo) {
      if (resendClickCount >= 2) {
        setDisableTwo(true); 
      }
      setCountdown(120);
      clearInterval(timerRef.current); // Clear any existing timer before starting a new one
      if (!processing) {
        processing = true;
        if (state?.state?.flag) {
  
          authCtl.getPhoneNoVerificationCodeFromCognito(username).then(data => {
            if (data.status === 'true') {
              NotifyInfo("A verification code was sent to your Phone number")
  
            } else {
              NotifyInfo(data.errorMessage)
            }
          })
        }
        else {
          const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(pass_key), {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
          });
          const ivString = CryptoJS.enc.Base64.stringify(iv);
          const encryptedString = encrypted.toString();
          const finalEncryptedPassword = `${ivString}:${encryptedString}`;
          authCtl.requestMFACode(username, finalEncryptedPassword, otpPath).then((data) => {
            if (data.Success === true) {
              if (otpPath === "sms") {
                NotifyInfo("A verification code was sent to your phone via SMS");
              }
              if (otpPath === "mail") {
                NotifyInfo("A verification code was sent to your email address.");
              }
            } else {
              NotifyError(data.errorMessage)
            }
            processing = false;
          }).catch(NotifyError);
  
        }
      }
      timerRef.current = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }
  };
    
  

  // useEffect(() => {
   

  //   document.addEventListener('keydown', handleKeyPress);
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   };
  // }, [disabled]);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setdisabled(true)
      VerifyOtp()

    }
  };
  const redirectTohome = () =>{
    history.replace("/purchaser-auth/login")
    }

  return (
    <div className='authPage'>
      <NotificationAlert ref={notifyRef} />
      <div className="wrap">
        <div className="row g-0">
          <div className="col-lg-6">
            <LoginLeft hideCursor={true}/>
          </div>
          <div className="col-lg-6">
            <div className="authRight h-100 p-4 p-lg-5">
              <div className="authRightContent">
              
                {/*state?.state?.flag ?
                  <>
                    <h3>Provide OTP to verify Number </h3>
                    <h6 className='mb-4 fs-6 fw-semi'>One Time Passcode for Number Verification</h6>
                  </>
                  :
                  <>
                    <h3>Enter OTP Code </h3>
                    <h6 className='mb-4 fs-6 fw-semi'>Your code has been sent to your OTP preferred delivery method</h6>
                  </>
                */}
                {otpPath =="sms" && verifyedPath!="verifyed" ?
                    <>
                   <div className="d-flex align-items-center back_button_design" style={{cursor:"pointer"}} onClick={redirectTohome}>
                          <IoArrowBackCircle className="fs-5 me-1" />
                          <p className=" d-flex justify-content-start my-0 me-sm-5 me-md-2 me-lg-1 me-0" >
                          Back
                        </p>
                        </div>
                     <h3>Provide OTP to verify Number </h3>
                      <h6 className='mb-4 fs-6 fw-semi'>One Time Passcode for Number Verification</h6>
                    </>
                    :
                    <>
                    <div className="d-flex align-items-center back_button_design" style={{cursor:"pointer"}} onClick={redirectTohome}>
                          <IoArrowBackCircle className="fs-5 me-1" />
                          <p className=" d-flex justify-content-start my-0 me-sm-5 me-md-2 me-lg-1 me-0" >
                          Back
                        </p>
                        </div>
                      <h3>Enter OTP Code </h3>
                      <h6 className='mb-4 fs-6 fw-semi'>Your code has been sent to your OTP preferred delivery method</h6>
                    </>
                  }
                <div className="formField ">
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1"><i className='bx bxs-lock-open'></i></InputGroup.Text>
                    <Form.Control
                      placeholder="Enter your OTP for verification"
                      aria-label="OTP"
                      aria-describedby="basic-addon1"
                      type='number'
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      onKeyUp={checkOTP}
                      className={otpError && 'border-danger'}
                      onKeyPress={handleKeyPress}
                    />
                  </InputGroup>
                </div>
                {otpError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{otpError}</p>}
                <div className="text-end mb-3">
                {!disableTwo ? (
                    <button className='text-primary border-0 bg-transparent p-0' onClick={resendMFA}>
                      <i className="bi bi-arrow-counterclockwise"></i> Resend OTP
                    </button>
                  ) : (
                    <p style={{fontWeight:"600"}}>Resend OTP available in {Math.floor(countdown / 60)}:{(countdown % 60).toString().padStart(2, '0')} minutes</p>
                  )}
                </div>
                {verifyLoader ? 
                 <button className='btn btn-primaryTwo w-100'  disabled >
                   Verifying...
                  <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                     
                  </button>
                  :
                  <button className='btn btn-primaryTwo w-100' onClick={VerifyOtp} >Verify</button>
              }
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProvideOtp;